import React from "react"
import { AlertProps } from '@mui/material/Alert';
import { StyledAlert } from "./styled"

interface IProps extends AlertProps {
  content?: string,
}

export const Alert = ({ children, content, icon, severity = "info" }: IProps) => {
  return (
    <StyledAlert severity={severity} icon={icon}>
      {content && <span dangerouslySetInnerHTML={{ __html: content }} />}
      {children}
    </StyledAlert>
  )
}
